import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Drawer,
  DrawerHeader,
  DrawerTitle
} from "@/components/ui/drawer";
import { AppDrawerContent } from "@/components/layouts/AppDrawerContent";
import { IconButton } from "@/components/ui/icon-button";
import { Close } from "@dreamhub/designsystem/icons";
import { DrawerTitle as CustomDrawerTitle } from "../../FieldManagement/components/DrawerTitle";
import { WorkflowCustomField } from "./components/WorkflowCustomField";

const TRANSLATION_KEY = "settings.deals.fieldManagement.drawer";

interface AddGeneralWorkflowFieldDrawerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  questionnaireId: string;
  forceChecklistItem?: boolean;
  enableAutofill?: boolean;
  onSave?: (fieldData: any) => void;
}

export const AddGeneralWorkflowFieldDrawer: React.FC<
  AddGeneralWorkflowFieldDrawerProps
> = ({
  isOpen,
  onOpenChange,
  questionnaireId,
  forceChecklistItem,
  enableAutofill = true,
  onSave
}) => {
  const { t } = useTranslation();

  const [isRequiredForPass, setIsRequiredForPass] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsRequiredForPass(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsRequiredForPass(false);
    onOpenChange(false);
  };

  const handleRequiredForPassChange = (required: boolean) => {
    setIsRequiredForPass(required);
  };

  const handleSave = (fieldData?: any) => {
    const finalData = fieldData
      ? { ...fieldData, isRequiredForPass }
      : { isRequiredForPass };
    onSave?.(finalData);
    handleClose();
  };

  const getTitle = () => {
    return (
      <CustomDrawerTitle
        title={t(`${TRANSLATION_KEY}.title`)}
        subtitle={t(`${TRANSLATION_KEY}.customField`)}
      />
    );
  };

  return (
    <Drawer
      open={isOpen}
      onOpenChange={onOpenChange}
      direction="right"
      modal={false}
      dismissible={false}
    >
      <AppDrawerContent isSettingsDrawer>
        <DrawerHeader>
          <DrawerTitle>
            {getTitle()}
          </DrawerTitle>
          <IconButton
            data-test="close-workflow-field-drawer"
            onClick={handleClose}
            variant="iconNoBg"
            size="md"
          >
            <Close />
          </IconButton>
        </DrawerHeader>
        <div className="flex w-full h-full flex-col">
          <WorkflowCustomField
            questionnaireId={questionnaireId}
            enableAutofill={enableAutofill}
            onBack={handleClose}
            onCancel={handleClose}
            onSave={handleSave}
            onRequiredForPassChange={handleRequiredForPassChange}
            forceChecklistItem={forceChecklistItem}
          />
        </div>
      </AppDrawerContent>
    </Drawer>
  );
};
